const TYPE = {
  TEL: "tel:",
  MAIL: "mailto:",
  LINK: "link",
};

export const contactsProperty = [
  {
    label: "Tel. Nos: ",
    property: "telephoneNumber",
    type: TYPE.TEL,
  },
  {
    label: "Cel. Nos: ",
    property: "cellphoneNumber",
    type: TYPE.TEL,
  },
  {
    label: "Facebook",
    property: "facebook",
    type: TYPE.LINK,
  },

  {
    label: "Email Address",
    property: "email",
    type: TYPE.MAIL,
  },
  {
    label: "Website",
    property: "website",
    type: TYPE.LINK,
  },
];
